import { useState } from 'react';
import { useRequestedPlan } from '#hooks/useRequestedPlan.ts';
import { Signup } from './free/Signup.tsx';
import { SignupPro } from './pro/SignupPro.tsx';
import { SignupSuccess } from './success/SignupSuccess.tsx';

export function SignupPage() {
  const [isSubmitted, setSubmitted] = useState(false);
  // If the user wants to sign up for the Pro plan, record it to localStorage so we can check after TOTP setup
  const [plan] = useRequestedPlan();

  if (isSubmitted) {
    return <SignupSuccess />;
  }

  if (plan === 'pro') {
    return (
      <SignupPro
        onSuccessfulSubmit={() => {
          setSubmitted(true);
        }}
      />
    );
  }

  return (
    <Signup
      onSuccessfulSubmit={() => {
        setSubmitted(true);
      }}
    />
  );
}
